import { render, staticRenderFns } from "./RhForm.vue?vue&type=template&id=4f5969b8&"
import script from "./RhForm.vue?vue&type=script&lang=js&"
export * from "./RhForm.vue?vue&type=script&lang=js&"
import style0 from "./RhForm.vue?vue&type=style&index=0&id=4f5969b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports